<template>
    <nav class="panel">
        <p class="panel-heading">
            PAYABLES
        </p>
        <VuePerfectScrollbar class="scroll-area" :settings="settings" @ps-scroll-y="scrollHandle">
            <a class="panel-block">
                <span class="panel-icon">
                  <i class="fas fa-book" aria-hidden="true"></i>
                </span>
                Nothing at the moment..
            </a>
        </VuePerfectScrollbar>
    </nav>
</template>

<script>
    import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    export default {
        components: {
            VuePerfectScrollbar: VuePerfectScrollbar
        },
        data() {
            return {
                settings: {
                    maxScrollbarLength: 60
                },
                threads: []
            }
        },
        mounted () {

        },
        methods: {
            scrollHandle(evt) {
                console.log(evt)
            }
        }
    }
</script>

<style scoped>
    .scroll-area {
        max-height: 330px;
    }
    small {
        font-size: 12px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Payables.vue